import { render, staticRenderFns } from "./OverviewContacts.vue?vue&type=template&id=21c8abcc&"
import script from "./OverviewContacts.vue?vue&type=script&lang=js&"
export * from "./OverviewContacts.vue?vue&type=script&lang=js&"
import style0 from "./OverviewContacts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports